import type { GameAppointment, UserTypeInEvent } from '@/services/appointments';

const userTypeOrder: UserTypeInEvent[] = [
  'referee_one',
  'referee_two',
  'referee_three',
  'secretary_score',
  'secretary_time',
  'secretary_4',
  'secretary_5',
  'commissioner',
  'secretary_information',
  'secretary_statistics',
  'secretary_statistics_2',
  'secretary_statistics_3',
  'delegate',
];

export const sortAppointments = (itemA: GameAppointment, itemB: GameAppointment) => {
  const indexA = userTypeOrder.indexOf(itemA.user_type_in_event);
  const indexB = userTypeOrder.indexOf(itemB.user_type_in_event);
  return indexA - indexB;
};
